"use strict";
/** @module BryxApi.SupportApi */
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../models");
var NoteMixin = /** @class */ (function () {
    function NoteMixin() {
    }
    NoteMixin.prototype.getNotes = function (entityType, entityId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.Note.parse, 'warn'));
        };
        this.http.get('/notes', {
            entityType: models_1.NoteEntityType[entityType],
            entityId: entityId,
        }, this.unauthenticatedCallback(wrappedCallback));
    };
    NoteMixin.prototype.createNote = function (entityType, entityId, importance, message, callback) {
        var _this = this;
        var body = {
            entityType: models_1.NoteEntityType[entityType],
            entityId: entityId,
            importance: models_1.NoteImportance[importance],
            message: message,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.Note.parse));
        };
        this.http.post('/notes', null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    NoteMixin.prototype.editNote = function (noteId, importance, message, callback) {
        var _this = this;
        var body = {
            importance: models_1.FieldUtils.getEditableParam(importance, function (v) { return models_1.NoteImportance[v]; }),
            message: models_1.FieldUtils.getEditableParam(message),
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/notes/" + noteId, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    NoteMixin.prototype.deleteNote = function (noteId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/notes/" + noteId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    return NoteMixin;
}());
exports.default = NoteMixin;
//# sourceMappingURL=NoteMixin.js.map